"use strict";
/**
 *
 * Component: AppDrwer.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.1
 * Data: 05/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@material-ui/core");

var mobx_react_1 = require("mobx-react");

var AppMenu_1 = require("./AppMenu");

var AppDrawer = function AppDrawer(props) {
  React.useEffect(function () {
    if (props.appState) {
      props.appState.menuState.setHiHaDrawer(true);
      props.appState.menuState.setDrawerVariant(props.variant);
    }
  }, [props.variant]);

  if (!props.appState) {
    return null;
  }

  var menuState = props.appState.menuState;
  var variant = props.variant === 'foldable' ? 'permanent' : props.variant || 'temporary';
  var width = menuState.drawerWidth;
  var marginHeader = props.appState.pantState.marginHeader;

  var style = __assign({
    overflowX: 'hidden',
    width: width,
    marginTop: marginHeader
  }, props.style);

  var children = React.Children.toArray(props.children);
  return React.createElement(core_1.Drawer, {
    variant: variant,
    open: menuState.openedDrawer,
    onClose: menuState.toogleDrawer,
    onMouseEnter: menuState.toogleFold,
    onMouseLeave: menuState.toogleFold
  }, React.createElement(AppMenu_1.default, {
    style: style,
    folded: menuState.foldedDrawer && menuState.foldableDrawer
  }, props.children && children.map(function (element, index) {
    return React.cloneElement(element, {
      folded: menuState.foldedDrawer && menuState.foldableDrawer,
      key: index
    });
  })));
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(AppDrawer));